import { extend } from 'flarum/common/extend';
import Icon from 'flarum/common/components/Icon';
// fof/share-social's modal, patched when its chunk registers.
const SHARE_MODAL = 'ext:fof/share-social/forum/components/ShareModal';
/**
 * The share modal opens with what is being shared: the discussion's title
 * and the forum's address, above the network tiles (share-social.less).
 */
export default function shareSocial() {
  extend(SHARE_MODAL, 'shareItems', function (items) {
    const discussion = this.discussion;
    if (!discussion) return;
    let host = '';
    try {
      host = new URL(discussion.shareUrl(), window.location.href).host;
    } catch {
      // Leave the address out rather than show a broken one.
    }
    items.add('bdPreview', m("div", {
      className: "BdSharePreview"
    }, m("span", {
      className: "BdSharePreview-icon"
    }, m(Icon, {
      name: "fas fa-link"
    })), m("span", {
      className: "BdSharePreview-text"
    }, m("span", {
      className: "BdSharePreview-title"
    }, discussion.title()), host && m("span", {
      className: "BdSharePreview-host"
    }, host))), 2000);
  });
}